"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var uuid_1 = require("uuid");
var keyboard = require("../../_Core/Keyboard");
var Icons_1 = require("../../Icons");
var Localization_1 = require("../../Localization");
var BaseModal_styles_1 = require("./BaseModal.styles");
var PortalWrapper_1 = require("./components/PortalWrapper");
exports.default = (function (_a) {
    var _b = _a.BorderRadius, BorderRadius = _b === void 0 ? "6px" : _b, CloseButtonHoverColor = _a.CloseButtonHoverColor, children = _a.children, _c = _a.CloseAriaLabel, CloseAriaLabel = _c === void 0 ? Localization_1.strings.Action_ClosePopup : _c, _d = _a.DisableClose, DisableClose = _d === void 0 ? false : _d, _e = _a.FooterColor, FooterColor = _e === void 0 ? "white" : _e, Header = _a.Header, _f = _a.HeaderColor, HeaderColor = _f === void 0 ? "white" : _f, HeaderTextColor = _a.HeaderTextColor, Height = _a.Height, _g = _a.ListenToBackgroundClick, ListenToBackgroundClick = _g === void 0 ? true : _g, _h = _a.MarginTopBottom, MarginTopBottom = _h === void 0 ? "0px" : _h, _j = _a.Offset, Offset = _j === void 0 ? { Top: "0", Left: "0" } : _j, OnCloseRequest = _a.OnCloseRequest, RenderFooter = _a.RenderFooter, Width = _a.Width;
    var sectionRef = React.createRef();
    var idToUse = uuid_1.v1();
    React.useEffect(function () {
        if (sectionRef.current) {
            sectionRef.current.focus();
        }
    }, []);
    var stopClick = function (e) {
        e.stopPropagation();
    };
    var handleContainerClick = function (e) {
        e.stopPropagation();
        if (ListenToBackgroundClick && !DisableClose) {
            OnCloseRequest();
        }
    };
    var handleCloseClick = function (e) {
        e.stopPropagation();
        if (!DisableClose) {
            OnCloseRequest();
        }
    };
    var handleKeyDown = function (e) {
        e.stopPropagation();
        if (keyboard.IsEscape(e) && !DisableClose) {
            OnCloseRequest();
        }
    };
    return (React.createElement(PortalWrapper_1.PortalWrapper, null,
        React.createElement(BaseModal_styles_1.ModalDiv, { onClick: handleContainerClick, Offset: Offset },
            React.createElement(BaseModal_styles_1.Section, { ref: sectionRef, theme: { Height: Height, Width: Width, Offset: Offset, MarginTopBottom: MarginTopBottom, BorderRadius: BorderRadius }, role: "dialog", "aria-labelledby": idToUse, onClick: stopClick, onKeyDown: handleKeyDown, tabIndex: 0 },
                React.createElement(BaseModal_styles_1.ModalHeader, { onKeyDown: handleKeyDown, HeaderColor: HeaderColor, HeaderTextColor: HeaderTextColor, BorderRadius: BorderRadius },
                    React.createElement(BaseModal_styles_1.CaptionDiv, { id: idToUse }, Header),
                    React.createElement(BaseModal_styles_1.CloseButton, { type: "button", onClick: handleCloseClick, onKeyDown: handleKeyDown, title: Localization_1.strings.Action_ClosePopup, "aria-label": CloseAriaLabel, ButtonColor: HeaderTextColor, CloseButtonHoverColor: CloseButtonHoverColor, disabled: DisableClose },
                        React.createElement(Icons_1.CloseThinIcon, { Height: "24px", Width: "24px" }))),
                React.createElement(BaseModal_styles_1.Article, null, children),
                RenderFooter &&
                    React.createElement(BaseModal_styles_1.Footer, { FooterColor: FooterColor, BorderRadius: BorderRadius }, RenderFooter())))));
});
